import React, { useState } from "react";

const NewQuestionSection = ({ questions = [] }) => {

  const [activeIndex, setActiveIndex] = useState(0);

  const renderAnswer = (q) => {
    if (!q) return null;
    if (q.type === "list") {
      return (
        <div className="space-y-4">
          <p className="text-lg md:text-xl leading-relaxed text-gray-900">{q.answer}</p>
          <ul className="list-disc pl-6 text-base md:text-lg space-y-1 text-gray-900">
            {q.items?.map((it, i) => <li key={i}>{it}</li>)}
          </ul>
          {/* {q.note && <p className="text-sm italic text-gray-600">{q.note}</p>} */}
          {q.note && <p className="text-base md:text-lg space-y-1 text-gray-900">{q.note}</p>}

        </div>
      );
    }
    return <p className="text-lg md:text-xl leading-relaxed text-gray-900">{q.answer}</p>;
  };

  return (
    // NOTE: change --outer-bg if your page background is different so curves blend perfectly
    <div className="w-full bg-white border border-gray-200 shadow-sm rounded-2xl">
      {/* Tabs */}
      <style>
        {
          `
          .no-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .no-scrollbar {
            -ms-overflow-style: none;  /* IE/Edge */
            scrollbar-width: none;     /* Firefox */
          }

          /* OR style scrollbar (instead of hiding) */
          .scrollbar-custom::-webkit-scrollbar {
            height: 6px;
          }
          .scrollbar-custom::-webkit-scrollbar-thumb {
            background: #a0aec0;  /* gray-400 */
            border-radius: 9999px;
          }
          .scrollbar-custom::-webkit-scrollbar-track {
            background: #edf2f7;  /* gray-100 */
          }`
        }
      </style>
      <ul className="flex w-full mb-[-1px] list-none overflow-x-auto no-scrollbar " id="myTab">
        {questions.map((q, i) => {
          const active = i === activeIndex;
          return (
            <li
              key={i}
              onClick={() => setActiveIndex(i)}
              className="flex-1 relative"
            >
              <span
                className={`block px-4 py-3 text-2xl text-center cursor-pointer select-none truncate relative
              ${active
                    ? "bg-white text-black border border-black border-b-0 rounded-t-xl z-20"
                    : "bg-transparent text-black"
                  }`}
              >
                {q.question}
              </span>

              {/* Left curve */}
              {active && activeIndex !== 0 && (
                <div className="absolute bottom-0 -left-[0.94rem] w-4 h-4 bg-white z-20">
                  <div className="absolute bottom-0 right-0 w-4 h-4 rounded-br-full border-r border-b border-black"></div>
                </div>
              )}

              {/* Right curve */}
              {active && activeIndex !== questions.length - 1 && (
                <div className="absolute bottom-0 -right-[0.95rem] w-4 h-4 bg-white z-20">
                  <div className="absolute bottom-0 left-0 w-4 h-4 rounded-bl-full border-l border-b border-black"></div>
                </div>
              )}
            </li>
          );
        })}
      </ul>

      {/* Tab Content */}
      <div
        className={`bg-white text-black border border-black rounded-xl p-5 relative z-10
      ${activeIndex === 0 ? "!rounded-tl-none" : ""}
      ${activeIndex === questions.length - 1 ? "!rounded-tr-none" : ""}
    `}
      >
        <div>{renderAnswer(questions[activeIndex])}</div>
      </div>
    </div>



  );
};

export default NewQuestionSection;



